<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :money="componentParams.money">
        </component>
    </div>
</template>
<script>
import MyInfo from './Info/MyInfo.vue'
import EditInfo from './Info/EditInfo.vue'

export default {
    name: 'PersonalInfo',
    components: {
        MyInfo,
        EditInfo,
    },
    data() {
        return {
            currentComponent: 'MyInfo',
            componentParams: {
                
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'MyInfo';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                this.componentParams = { ...this.componentParams, ...params };
            }
            this.currentComponent = componentName;
        }
    }
}
</script>
<style scoped>
/* 可以根据需要添加样式 */
</style>